export default __webpack_public_path__ + "static/media/Header-9.d30694a6.jpg";